export interface SymbolLookupButtonClickResolverOptions {
  readonly disabled: boolean;
  readonly hasInputValue: boolean;
  readonly hasSymbols: boolean;
}

export interface SymbolLookupButtonClickAction {
  readonly kind: 'none' | 'validateAndSelect' | 'markTouched';
}

/**
 * Resolves the button-click action while preserving SymbolLookupComponent behavior.
 */
export function resolveSymbolLookupButtonClickAction(
  options: SymbolLookupButtonClickResolverOptions
): SymbolLookupButtonClickAction {
  const {
    disabled,
    hasInputValue,
    hasSymbols
  }: SymbolLookupButtonClickResolverOptions = options;

  if (disabled) {
    return { kind: 'none' };
  }

  if (hasInputValue && hasSymbols) {
    return { kind: 'validateAndSelect' };
  }

  if (hasInputValue) {
    return { kind: 'markTouched' };
  }

  return { kind: 'none' };
}

